import {useEffect, useState} from "react";
import {Client} from "../Api/Client";
import SimpleTable from "../Components/SimpleTable";
import Accordion from "../Components/Accordion";
import Spinner from "../Components/Spinner";
import ActionButton from "../Components/ActionButton";
import {mapRoutesEnToSv} from "../Utils/routes";

function TableSection({content, id, onLoad}: any) {
    const [isLoading, setIsLoading] = useState(false);
    const [sort, setSort] = useState('count');
    const [sortBy, setSortBy] = useState('desc');
    const [sectionData, setSectionData] = useState<any>([]);

    const total = content.tRows ? content.tRows : sectionData.length;
    const isLight = content.template === 'light';

    async function getSectionData(sort: string, sortBy: string, signal: any) {
        setIsLoading(true);
        Client.get(content.endpoint, {params: {sort: sort, sort_by: sortBy, limit: content.tRows}, signal: signal})
            .then((response) => {
                setSectionData(response.data.data.table ?? response.data.data ?? [])
                onLoad();
                setTimeout(() => {
                    setIsLoading(false)
                }, 150);
            })
            .catch((e) => {
                console.log(e.message)
            })
    }

    useEffect(() => {
        const abortController = new AbortController();
        getSectionData(sort, sortBy, abortController.signal)

        return () => abortController.abort();
    }, [sort, sortBy, content.endpoint])

    function onSortChangeHandler(sort: string, sortBy: string) {
        setSort(sort);
        setSortBy(sortBy);
    }

    return (
        <div className="relative" id={id}>
            {isLoading && <Spinner/>}
            <Accordion icon={content.icon} title={content.title} description={content.text} isLight={isLight}>
                {sectionData?.length === 0
                    ? <p className="font-body">There is no such data yet.</p>
                    : <>
                        <div className="xl:flex xl:gap-6">
                            <div className="mb-2.5 xl:flex-1 rounded-md ps-2.5 pb-2.5 max-h-[55vh] xl:max-h-[70vh] overflow-auto table-scroller">
                                <SimpleTable
                                    data={sectionData}
                                    onSortChange={onSortChangeHandler}
                                    total={total}
                                    isLight={isLight}
                                    head={content.tHead}
                                />
                            </div>
                        </div>
                        {content.tRows && content.tRows <= sectionData.length &&
                            <ActionButton href={mapRoutesEnToSv(content.endpoint)} state={{ prevPath: window.location.pathname + '#' + id }}>
                                {content.viewAllText ?? 'Visa fler'}
                            </ActionButton>
                        }
                    </>
                }

            </Accordion>
        </div>
    );
}

export default TableSection;